export function embedOverlay() {
	const videoContainers = document.querySelectorAll('.wp-block-embed');

	videoContainers.forEach((videoContainer) => {
		const iframe = videoContainer.querySelector('iframe');
		const videoId = iframe?.dataset?.id;

		// Create overlay element
		const overlay = document.createElement('div');
		overlay.classList.add('wp-block-embed__overlay');

		// Check for data-img on the parent <figure>
		const figure = videoContainer.closest('figure');
		const customImg = figure?.dataset?.img;

		if (customImg) {
			overlay.style.backgroundImage = `url(${customImg})`;
		} else if (videoId) {
			overlay.style.backgroundImage = `url(https://img.youtube.com/vi/${videoId}/maxresdefault.jpg)`;
		}

		overlay.style.backgroundSize = 'cover';
		overlay.style.backgroundPosition = 'center';

		const playBtn = document.createElement('div');
		playBtn.className = 'play-button';
		playBtn.innerHTML = ` <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="36" cy="36" r="36" /> <path d="M28 24L52 36L28 48V24Z" /> </svg>`;
		overlay.appendChild(playBtn);

		overlay.onclick = function () {
			overlay.style.display = 'none';
			if (iframe && iframe.src.indexOf('autoplay') === -1) {
				iframe.src += (iframe.src.includes('?') ? '&' : '?') + 'autoplay=1';
			}
		};

		videoContainer.appendChild(overlay);
	});

	// Lazy-load the iframe
	document.querySelectorAll('.farlo-ui-video').forEach((container) => {
		const iframe = container.querySelector('iframe');
		if (iframe?.dataset?.src) {
			iframe.src = iframe.dataset.src;
		}
	});
}
